/**
 * Settings → Subscription route (plan, usage, add-ons, activation).
 * @see apps/web/src/features/settings/billing/billing-page.tsx
 */
import { createFileRoute, notFound } from "@tanstack/react-router";
import { hasPermission } from "@flint/api-contract";
import { BillingPage } from "../../../../features/settings/billing/billing-page.tsx";
import { meQueryOptions } from "../../../../lib/session.ts";

export const Route = createFileRoute("/(workspace)/settings/subscription/")({
  // URL-level `billing.manage` gate — see /settings/company/index.tsx for rationale.
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions).catch(() => null);
    const perms = me?.company?.permissions ?? [];
    if (!hasPermission(perms, "billing.manage")) {
      throw notFound();
    }
  },
  component: BillingPage,
});
